/**
 * RevenueSchedulesApiService — API-first revenue schedule operations.
 */

import { ApiClient } from '../ApiClient.js';

export class RevenueSchedulesApiService {
    static async listByDeal(dealId, { page = 1, per_page = 50 } = {}) {
        return ApiClient.get(`/api/v1/deals/${encodeURIComponent(dealId)}/schedules`, { page, per_page });
    }

    static async create(dealId, payload) {
        return ApiClient.post(`/api/v1/deals/${encodeURIComponent(dealId)}/schedules`, payload);
    }

    static async update(dealId, scheduleId, payload) {
        return ApiClient.put(`/api/v1/deals/${encodeURIComponent(dealId)}/schedules/${encodeURIComponent(scheduleId)}`, payload);
    }

    static async generateForDeal(dealId, payload = {}) {
        return ApiClient.post(`/api/v1/deals/${encodeURIComponent(dealId)}/schedules/generate`, payload);
    }

    static async updateStatus(scheduleId, { status, ...rest } = {}) {
        return ApiClient.patch(`/api/v1/schedules/${encodeURIComponent(scheduleId)}/status`, { status, ...rest });
    }

    static async linkZohoInvoice(dealId, scheduleId, payload) {
        return ApiClient.post(
            `/api/v1/deals/${encodeURIComponent(dealId)}/schedules/${encodeURIComponent(scheduleId)}/link-zoho`,
            payload
        );
    }

    static async unlinkZohoInvoice(dealId, scheduleId) {
        return ApiClient.post(
            `/api/v1/deals/${encodeURIComponent(dealId)}/schedules/${encodeURIComponent(scheduleId)}/unlink-zoho`,
            {}
        );
    }
}
